<template>
  <el-cascader :size="size" :options="options" v-model="provinces" @change="dynamicHandleChange" :disabled="disabled"
    :placeholder="placeholder" :parameters="parameters"></el-cascader>
</template>

<script>
/*
 provinceAndCityData - 省市两级联动
 provinceAndCityDataPlus - 省市两级联动，市显示“全部”选项
 regionData - 省市区三级联动
 regionDataPlus - 省市区三级联动，区显示“全部”选项
*/
import { regionData } from "element-china-area-data";
export default {
  props: {
    size: {
      type: String,
      default: "mini", // 默认大小为mini
    },
    options: {
      type: Array,
      default: () => regionData, // 默认选项数据为空数组
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请选择省市区", // 默认提示文字为"请选择省市区"
    },
    parameters: {
      type: String,
      default: "all", // code：地区编码，name：地区名称，all：包含地区编码和地区名称
    },
    value: String,// model值
  },
  data() {
    return {
      provinces: [], // 选中的省市区数据，默认为空数组
    };
  },
  watch: {
    value: {
      handler(newValue) {
        // 确保选择框中的值已经更新完成
        this.$nextTick(() => {
          if (newValue) {
            this.provinces = newValue.split("/");
          } else {
            this.provinces = []
          }
        });
      },
      immediate: true,
    },
  },
  methods: {
    dynamicHandleChange(e) {
      this.$emit("input", this.figure(e))
      if (this.parameters == "name") {
        this.$emit("change", this.ideograph(e));
      } else if (this.parameters == "code") {
        this.$emit("change", this.figure(e));
      } else {
        this.$emit("change", this.all(e));
      }
    },
    // 传递中文数据
    ideograph(code) {
      const areas = [];
      if (Array.isArray(code) && code.length) {
        let region = this.options;
        for (let i = 0; i < code.length; i++) {
          const item = code[i];
          const found = region.find((regionItem) => regionItem.value === item);
          if (found) {
            areas.push(found.label); // 直接将中文推入数组中
            region = found.children || [];
            if (i === code.length - 1) {
              // 最后一个区域，可以打印或进行其他处理
            }
          } else {
            break;
          }
        }
      }
      return areas.join("/");
    },
    // 传递code数据
    figure(code) {
      return code.join("/");
    },
    // 获取完整数据
    all(code) {
      const areas = [];
      if (Array.isArray(code) && code.length) {
        let region = this.options;
        for (let i = 0; i < code.length; i++) {
          const item = code[i];
          const found = region.find((regionItem) => regionItem.value === item);
          if (found) {
            areas.push(found);
            region = found.children || [];
            if (i === code.length - 1) {
              // 最后一个区域，可以打印或进行其他处理
            }
          } else {
            break;
          }
        }
      }
      return areas;
    }
  },
};
</script>
